// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useEffect, useMemo, useRef, useState}
    from 'react';
import cn from 'classnames';
import {Settings_context} from '../settings_ctx';
import {Editor} from '../../../shared/editor/editor';
import styles from './blog_post.module.less';

function process_html_classes(html: string, process_class_name: (
    class_name: string)=>string): string
{
    return html.replace(/class\s*=\s*["']([^"']+)["']/g, (match, list)=>{
        let new_list = list.split(/\s+/).map(process_class_name).join(' ');
        return `class="${new_list}"`;
    });
}

interface i_blog_post_props {
    category: string;
    category_url: string;
    read_time: string;
    publish_date: string;
    title: string;
    image_url: string;
    image_alt: string;
    author_name: string;
    author_position?: string;
    author_avatar: string;
    share_url: string;
    article_html: string;
}

interface i_nav_item {
    id: string;
    text: string;
    subitems: i_nav_item[];
}

const Icon_twitter = ()=>
  <svg width="16" height="13" viewBox="0 0 16 13" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M15.1373 1.45968C14.5807 1.70635 13.9827 1.87301 13.354
      1.94835C14.0027 1.56021 14.488 0.949323 14.7193 0.229679C14.1099 0.591672
      13.4429 0.846476 12.7473 0.983013C12.2796 0.483589 11.66 0.152563 10.9849
      0.0413283C10.3097 -0.0699065 9.61673 0.0448733 9.01349 0.367848C8.41025
      0.690822 7.93052 1.20392 7.64877 1.82748C7.36702 2.45104 7.29902 3.15018
      7.45533 3.81635C6.22046 3.75434 5.01242 3.43338 3.90962 2.87428C2.80681
      2.31519 1.83389 1.53045 1.054 0.571012C0.787333 1.03101 0.634 1.56435
      0.634 2.13235C0.633702 2.64368 0.759622 3.14717 1.00059 3.59817C1.24155
      4.04916 1.59011 4.43371 2.01533 4.71768C1.52218 4.70199 1.03992 4.56874
      0.608667 4.32901V4.36901C0.608617 5.08617 0.856688 5.78127 1.31079
      6.33634C1.76489 6.89142 2.39705 7.2723 3.1 7.41435C2.64252 7.53816
      2.16289 7.55639 1.69733 7.46768C1.89566 8.08476 2.282 8.62436 2.80224
      9.01096C3.32249 9.39756 3.95061 9.6118 4.59867 9.62368C3.49856 10.4873
      2.13992 10.9557 0.741333 10.9537C0.493587 10.9537 0.246051 10.9393 0
      10.9103C1.41965 11.8231 3.07223 12.3076 4.76 12.3057C10.4733 12.3057
      13.5967 7.57368 13.5967 3.46968C13.5967 3.33635 13.5933 3.20168 13.5873
      3.06835C14.1949 2.629 14.7193 2.08494 15.136 1.46168L15.1373 1.45968Z"
      fill="#7D7D7D"/>
</svg>;

const Icon_facebook = ()=>
  <svg width="9" height="16" viewBox="0 0 9 16" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M8.0075 8.9995L8.452 6.104H5.6735V4.225C5.6735 3.433 6.0615
      2.6605 7.306 2.6605H8.569V0.1955C8.569 0.1955 7.423 0 6.327 0C4.039 0
      2.5435 1.387 2.5435 3.8975V6.1045H0V9H2.5435V16H5.6735V9L8.0075 8.9995Z"
      fill="#7D7D7D"/>
</svg>;

const Icon_linkedin = ()=>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.88251 1.94126C3.88251
      3.01338 3.01338 3.88251 1.94125 3.88251C0.869126 3.88251 0 3.01338 0
      1.94126C0 0.86913 0.869126 0 1.94125 0C3.01338 0 3.88251 0.86913 3.88251
      1.94126ZM12.6564 5.03024C12.5331 5.01483 12.4022 5.00713 12.2712
      4.99942L12.2712 4.99942C10.3993 4.92239 9.3439 6.03168 8.97414
      6.50929C8.87399 6.64025 8.82777 6.71728 8.82777
      6.71728V5.29215H5.63086V15.9537H8.82777H8.97414V12.7028V10.9464C8.97414
      10.8638 8.97343 10.7805 8.97273 10.6968V10.6967C8.96725 10.0477 8.96157
      9.3763 9.28227 8.78949C9.59041 8.23485 10.145 7.95753 10.769
      7.95753C12.6178 7.95753 12.6564 9.62916 12.6564
      9.78323V9.79864V15.9999H15.9996V9.04371C15.9996 6.66336 14.7902 5.26134
      12.6564 5.03024ZM3.61292 5.26142H0.269642V15.9229H3.61292V5.26142Z"
      fill="#7D7D7D"/>
</svg>;

const Icon_copy = ()=>
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.45703 11.1144L11.1139 5.45752M3.33579 7.57861L1.92157
        8.99283C0.359476 10.5549 0.359476 13.0876 1.92157 14.6497C3.48367
        16.2118 6.01633 16.2118 7.57843 14.6497L8.99264 13.2355M7.57812
        3.33579L8.99234 1.92157C10.5544 0.359476 13.0871 0.359476 14.6492
        1.92157C16.2113 3.48367 16.2113 6.01633 14.6492
        7.57843L13.235 8.99264"
      stroke="#7D7D7D" stroke-width="1.5" stroke-linecap="round"
      stroke-linejoin="round"/>
</svg>;

const Share = ({share_url}: {share_url: string})=>{
    const on_twitter = (ev: React.MouseEvent)=>{
        ev.preventDefault();
        const url = `https://twitter.com/intent/tweet?url=${
            encodeURIComponent(share_url)}`;
        window.open(url, '_blank', 'width=600,height=400');
    };
    const on_facebook = (ev: React.MouseEvent)=>{
        ev.preventDefault();
        const url = `https://www.facebook.com/sharer/sharer.php?u=${
            encodeURIComponent(share_url)}`;
        window.open(url, '_blank', 'width=600,height=400');
    };
    const on_linkedin = (ev: React.MouseEvent)=>{
        ev.preventDefault();
        const url = `https://www.linkedin.com/sharing/share-offsite/?url=${
            encodeURIComponent(share_url)}`;
        window.open(url, '_blank', 'width=600,height=400');
    };
    const on_copy = (ev: React.MouseEvent)=>{
        ev.preventDefault();
        void navigator.clipboard.writeText(share_url);
        window.alert('Link copied to clipboard');
    };
    return <div className={styles.share}>
      <a href="#" onClick={on_twitter}><Icon_twitter/></a>
      <a href="#" onClick={on_facebook}><Icon_facebook/></a>
      <a href="#" onClick={on_linkedin}><Icon_linkedin/></a>
      <a href="#" onClick={on_copy}><Icon_copy/></a>
    </div>;
};

const Author = ({name, avatar, position}:
{name: string; avatar: string; position?: string})=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.author}>
      <div className={styles.author_pic}
        style={{backgroundImage: `url(${avatar})`}}/>
      <div className={styles.author_text_container}>
        <p className={cn(theme.u4, styles.author_text)}>{name}</p>
        {position &&
          <p className={cn(theme.u4, styles.author_text)}>{position}</p>}
      </div>
    </div>;
};

const Table_of_contents = ({article_html}: {article_html: string})=>{
    const {theme} = useContext(Settings_context);
    const [nav_items, set_nav_items] = useState<i_nav_item[]>([]);
    const [active_id, set_active_id] = useState<string>('');
    const observer_ref = useRef<IntersectionObserver | null>(null);
    const processed_html = useMemo(()=>
        process_html_classes(article_html, class_name=>{
            if (theme[class_name])
                return theme[class_name];
            return class_name;
        }), [article_html, theme]);
    useEffect(()=>{
        const parser = new DOMParser();
        const doc = parser.parseFromString(processed_html, 'text/html');
        const elements = doc.querySelectorAll('[id]');
        const items: i_nav_item[] = [];
        let current_chapter: i_nav_item | null = null;
        elements.forEach(el=>{
            const id = el.getAttribute('id');
            const text = el.textContent || '';
            if (id && !id.includes('_subitem'))
            {
                // Main chapter
                current_chapter = {id, text, subitems: []};
                items.push(current_chapter);
            }
            else if (id && id.includes('_subitem') && current_chapter)
              current_chapter.subitems.push({id, text, subitems: []});
        });
        set_nav_items(items);
    }, [processed_html]);
    useEffect(()=>{
        observer_ref.current = new IntersectionObserver(
            entries=>{
                entries.forEach(entry=>{
                    if (entry.isIntersecting)
                    {
                        const id = entry.target.getAttribute('id');
                        if (id)
                        {
                            const parent_chapter = nav_items.find(item=>
                                item.id === id ||
                                item.subitems.some(sub=>sub.id === id)
                            );
                            if (parent_chapter)
                                set_active_id(parent_chapter.id);
                        }
                    }
                });
            },
            {rootMargin: '-72px 0px -60% 0px'}
        );
        nav_items.forEach(item=>{
            const el = document.getElementById(item.id);
            if (el && observer_ref.current)
                observer_ref.current.observe(el);
            item.subitems.forEach(subitem=>{
                const sub_el = document.getElementById(subitem.id);
                if (sub_el && observer_ref.current)
                    observer_ref.current.observe(sub_el);
            });
        });
        return ()=>{
            if (observer_ref.current)
                observer_ref.current.disconnect();
        };
    }, [nav_items]);
    const scroll_to = (id: string)=>{
        const el = document.getElementById(id);
        if (el)
        {
            const y = el.getBoundingClientRect().top + window.pageYOffset - 72;
            window.scrollTo({top: y, behavior: 'smooth'});
        }
    };
    return <div className={styles.toc}>
      <h3 className={cn(theme.u4, theme.med, theme.color_n600,
        styles.toc_title)}>
        IN THIS ARTICLE:
      </h3>
      <nav className={styles.toc_nav}>
        {nav_items.map(item=>
          <div key={item.id} className={styles.toc_chapter}>
            <a href={`#${item.id}`}
              className={cn(styles.toc_link,
                {[styles.active]: active_id==item.id})}
              onClick={ev=>{
                ev.preventDefault();
                scroll_to(item.id);
              }}>
              <p className={cn(theme.p3,
                {
                  [theme.color_n700]: active_id==item.id,
                  [theme.med]: active_id==item.id,
                })}>{item.text}</p>
            </a>
            {active_id === item.id && item.subitems.length > 0 &&
              <div className={styles.toc_subitems}>
                {item.subitems.map(subitem=><a key={subitem.id}
                  href={`#${subitem.id}`}
                  className={styles.toc_sublink}
                  onClick={ev=>{
                    ev.preventDefault();
                    scroll_to(subitem.id);
                  }}>
                    <p className={theme.p3}>{subitem.text}</p>
                  </a>
                )}
              </div>
            }
          </div>
        )}
      </nav>
    </div>;
};

export const Blog_post = (props: i_blog_post_props)=>{
    const {theme} = useContext(Settings_context);
    const content_ref = useRef<HTMLDivElement>(null);
    const processed_html = useMemo(()=>
        process_html_classes(props.article_html, class_name=>{
            if (theme[class_name])
                return theme[class_name];
            return class_name;
        }), [props.article_html, theme]);
    return <div className={cn(theme.root, styles.root)}>
      <div className={theme.container}>
        <div className={styles.layout}>
          <div className={styles.main_content}>
            <div className={styles.article_info}>
              <div className={styles.meta}>
                <a href={props.category_url}>
                  <p className={cn(theme.p2, theme.med)}>{props.category}</p>
                </a>&nbsp;&bull;&nbsp;
                <p className={cn(theme.p2, theme.med)}>{props.read_time}</p>
              </div>
              <p className={cn(theme.u3, theme.reg, styles.date_lg)}>
                {props.publish_date}
              </p>
            </div>
            <h1 className={cn(theme.H3, styles.title)}>{props.title}</h1>
            <p className={cn(theme.u3, theme.reg, styles.date_sm)}>
                {props.publish_date}
              </p>
            {props.image_url &&
              <div className={styles.featured_image}>
                <img src={props.image_url} alt={props.image_alt}/>
              </div>}
            <div className={styles.after_image}>
              <Author name={props.author_name}
                avatar={props.author_avatar} position={props.author_position}/>
              <Share share_url={props.share_url} />
            </div>
            <div ref={content_ref} className={styles.article_content}
              dangerouslySetInnerHTML={{__html: processed_html}}/>
            <div className={styles.end_share}>
              <Share share_url={props.share_url}/>
            </div>
          </div>
          <aside className={styles.sidebar}>
            <Table_of_contents article_html={props.article_html} />
          </aside>
        </div>
      </div>
    </div>;
};

interface i_blog_post_editor_props {
    value: i_blog_post_props;
    on_change: (new_value: i_blog_post_props)=>void;
    on_cancel: ()=>void;
}

export const Blog_post_editor = (props: i_blog_post_editor_props)=>{
    const {value, on_change, on_cancel} = props;
    const [state, set_state] = useState(value);
    return <div>
        <p className={styles.editor_note}>
          Table of Contents requires HTML elements with IDs. Main chapters
          should have IDs like "chapter-name". Subitems must follow the
          pattern "chapter-name_subitem1", "chapter-name_subitem2", etc.
          <pre className={styles.editor_example}>
            {'<h2 id="what-is-vpn">What is VPN?</h2> \n'}
            {'<h3 id="what-is-vpn_subitem1">Privacy Protection</h3> \n'}
            {'<h3 id="what-is-vpn_subitem2">Secure Connection</h3> \n'}
          </pre>
          Copy HTML of {'<div class="article">'}, paste it to AI and use this
          prompt to clean it up before adding to the editor:
          <pre className={styles.editor_example}>
            {`You are an HTML cleaning assistant. When given HTML 
            content, you must perform the following transformations: 
            1. Remove all HTML comments (<!-- ... -->). 2. Remove 
            only CSS classes with 'wp-' prefix from all tags, 
            keeping other CSS classes intact. 3. Remove <strong> 
            tags from headers (h2, h3, h4) while keeping the text 
            content. 4. Remove <figure> wrapper tags from tables, 
            keeping only the <table> element and its contents. 5. 
            Apply ID structure based on heading hierarchy: <h2> 
            elements assign simple, descriptive IDs based on content 
            (e.g., id="introduction", id="what-is-vpn"), <h3> 
            elements assign IDs with parent context plus _subitem 
            and incremental numbers (e.g., id="introduction_subitem1", 
            id="introduction_subitem2"), <h4> elements keep with NO 
            id attribute. 6. Remove all spaces and line breaks 
            between tags, output should be compact with no whitespace 
            between closing and opening tags. 7. Keep all other HTML 
            intact: paragraphs, links, emphasis tags (<em>), lists, 
            tables, etc. remain unchanged except for the rules above. 
            Example input: <!-- wp:heading --> <h2 class="wp-block-
            heading custom-class"><strong>Introduction</strong></h2> 
            <!-- /wp:heading --> <!-- wp:heading {"level":3} --> <h3 
            class="wp-block-heading another-class"><strong>What is 
            VPN?</strong></h3> <!-- /wp:heading --> <!-- wp:table --> 
            <figure class="wp-block-table"><table class="has-fixed-
            layout custom-table"><tbody><tr><td>Data</td></tr>
            </tbody></table></figure> <!-- /wp:table -->. Example 
            output: <h2 id="introduction" class="custom-class">
            Introduction</h2><h3 id="introduction_subitem1" class=
            "another-class">What is VPN?</h3><table class="custom-
            table"><tbody><tr><td>Data</td></tr></tbody></table>. Now 
            process the following HTML according to these rules:`}
          </pre>
        </p>
      <Editor value={state}
        on_change={v=>{
          on_change(v);
          set_state(v);
        }}
        on_cancel={on_cancel}
        on_save={()=>on_change(state)}
        editors={[
          {key: 'category', label: 'Category', type: 'text'},
          {key: 'category_url', label: 'Category URL', type: 'text'},
          {key: 'read_time', label: 'Read time (e.g., "12 min read")',
            type: 'text'},
          {key: 'publish_date',
            label: 'Publish date (e.g., "Jun 14, 2021")',
            type: 'text'},
          {key: 'title', label: 'Title', type: 'text'},
          {key: 'image_url', label: 'Image URL', type: 'text'},
          {key: 'image_alt', label: 'Image alt text', type: 'text'},
          {key: 'author_name', label: 'Author name', type: 'text'},
          {key: 'author_position', label: 'Author position (optional)',
            type: 'text'},
          {key: 'author_avatar', label: 'Author avatar URL',
            type: 'text'},
          {key: 'share_url', label: 'Share URL', type: 'text'},
          {key: 'article_html', label: 'Article HTML content',
            type: 'textarea'},
        ]}
        title="Blog Post"
      />
    </div>;
};
